export default {
  date: 'March 15, 2024',
  title: 'EU AI Act: first regulation on artificial intelligence',
  description: 'This document sets out obligations for the use of AI, based on its potential risks and impact.',
  id: 'first-regulation-on-AI',
  jsx: () => (
    <div class='novelty__text'>
      <p>This document sets out obligations for the use of AI, based on its potential risks and impact.</p>
      <p>
        The new rules prohibit certain AI applications that may threaten citizens' rights, such as biometric categorization systems based on confidential characteristics or the non-targeted collection of facial images from the internet. It also prohibits emotion recognition in the workplace and the
        use of AI to manipulate people's behavior.
      </p>
      <p>The law establishes clear obligations for high-risk AI systems, such as critical infrastructure and migration management, including risk assessment and reduction, transparency, and human oversight.</p>
      <p>Our service, Getfloorplan, guarantees full compliance with all requirements of the new Artificial Intelligence Act. We continue to strive for high standards of security and ethics in the use of our technologies, providing reliable solutions for our clients in all countries.</p>
      <p>Following technical clarifications, the Act must be formally adopted by the Council of the EU and come into force twenty days after publication in the Official Journal of the European Union, fully applicable within 24 months.</p>
    </div>
  ),
  thumb: 'news/8.webp',
};
